import { useNode } from '@craftjs/core';
import React, { useCallback } from 'react';
import { Divider } from '@descope/page-editor-components';
import { EditorDividerSettings } from './EditorDividerSettings';

const EditorDivider = (props: React.ComponentProps<typeof Divider>) => {
	const {
		connectors: { connect, drag }
	} = useNode();

	const refCb = useCallback(
		(ref: HTMLDivElement) => connect(drag(ref)),
		[connect, drag]
	);

	return <Divider ref={refCb} {...props} />;
};

EditorDivider.craft = {
	name: 'Divider',
	props: {
		children: 'Text',
		italic: false,
		typography: 'body1',
		vertical: false
	},
	related: {
		settings: EditorDividerSettings
	}
};

export { EditorDivider };
